module.exports = __webpack_public_path__ + "img/new_index_banner2.14efede4.jpg";